import * as React from 'react';
import {
    AchatsAppDispatch,
    ReminderPublisher,
    useAchatsService,
} from '@europrocurement/l2d-domain';

import { useApiRequestControllable } from '@europrocurement/l2d-modules';

import { useDispatch } from 'react-redux';
import CustomCommentSection from './CustomCommentSection';

type CommentEditionModalProps = {
    reminderPublisher?: ReminderPublisher;
    onClose?: () => void;
};

const CommentEditionModal: React.FunctionComponent<CommentEditionModalProps> = function ({
    reminderPublisher,
    onClose,
}: CommentEditionModalProps) {
    const dispatch = useDispatch<AchatsAppDispatch>();
    const [customMessage, setCustomMessage] = React.useState<string>('');
    const { request: requestUpdateCustomComment, requestState: requestStateUpdateCustomComment } =
        useApiRequestControllable();

    const { reminderPublisherApi, selectReminderPublisher } = useAchatsService();

    /**
     * Synchronise l'état local avec les données du rappel fournisseur
     */
    React.useEffect(() => {
        if (reminderPublisher?.customMessage) {
            setCustomMessage(reminderPublisher.customMessage);
        }
    }, [reminderPublisher]);

    /**
     * Envoie le commentaire à l'API et met à jour le store Redux en cas de succès
     *
     * @param newComment - Le nouveau commentaire à sauvegarder
     */
    const handleSaveCustomComment = (newComment: string) => {
        if (!reminderPublisher?.id) return;

        requestUpdateCustomComment(
            () =>
                reminderPublisherApi.updateMailContentReminderPublisherItem({
                    id: reminderPublisher?.id as string,
                    updateMailContentReminderPublisherItemRequest: {
                        customMessage: newComment,
                    },
                }),
            {
                withToaster: true,
                successMessage: 'Commentaire enregistré avec succès',
                successCallback: () => {
                    if (reminderPublisher.id) {
                        dispatch(selectReminderPublisher({ id: reminderPublisher.id }));
                    }
                    setCustomMessage(newComment);

                    if (onClose) {
                        onClose();
                    }
                },
            },
        );
    };

    return (
        <CustomCommentSection
            comment={customMessage}
            isSaving={requestStateUpdateCustomComment.isProcessing}
            onSave={handleSaveCustomComment}
            onClose={onClose}
        />
    );
};

export default CommentEditionModal;
